import { PendingRecharge } from '@/modules/collections/pendingRecharges/types/PendingRecharge.ts'

export const pendingResponse: PendingRecharge = {
  total: 2,
  totalPages: 1,
  limit: 10,
  currentPage: 0,
  data: [
    {
      id: 'bc7f9d01-af3e-426d-9ada-df9fac593aed',
      transferNumber: 'TRF000018',
      transferDate: '2024-04-25T00:00:00Z',
      transferAmount: 101.8,
      bank: {
        id: 1,
        name: 'Banco de Venezuela, S.A. Banco Universal',
        code: '0102',
        literalCode: '',
        photo: null,
        active: true
      },
      paymentType: {
        id: 2,
        code: 'TRANSFER_BS',
        name: 'Transferencia o Depósito',
        photo: null,
        active: true
      },
      currencyResponse: {
        code: 'BS',
        exchangeBuy: 1.0,
        exchangeSell: 1.0,
        mainCurrency: false
      },
      transaction: {
        id: 13,
        amount: 10.0,
        description: 'Recarga pendiente',
        reference: 'REC123546789',
        type: 'RECHARGE',
        status: 'PENDING',
        wallet: {
          id: '123456789012345678901234567890123456',
          balance: 85.0,
          documentNumber: '12356',
          currency: {
            code: 'USD',
            exchangeBuy: 1.0,
            exchangeSell: 1.0,
            mainCurrency: true
          },
          status: 'ACTIVE'
        },
        createAt: '2025-09-03T16:30:01.592128Z',
        details: {
          currencyCalculation: {
            BS: {
              amount: 100.0,
              exchangeRate: 36.5
            },
            USD: {
              amount: 2.74,
              exchangeRate: 1.0
            }
          }
        }
      },
      payPhone: null,
      bankOrigin: null,
      exchangeRate: 36.5,
      file: 'transfer_TRF000018_20250903210239710.png'
    },
    {
      id: 'a4d7c02b-29a8-4b9b-9f84-45c3e4af7e99',
      transferNumber: 'TRF000019',
      transferDate: '2024-05-10T00:00:00Z',
      transferAmount: 250.5,
      bank: {
        id: 2,
        name: 'Banco Mercantil, C.A.',
        code: '0105',
        literalCode: 'MERC',
        photo: null,
        active: true
      },
      paymentType: {
        id: 3,
        code: 'TRANSFER_USD',
        name: 'Transferencia en Divisas',
        photo: null,
        active: true
      },
      currencyResponse: {
        code: 'USD',
        exchangeBuy: 1.0,
        exchangeSell: 1.0,
        mainCurrency: true
      },
      transaction: {
        id: 14,
        amount: 50.0,
        description: 'Pago de servicio',
        reference: 'REC987654321',
        type: 'PAYMENT',
        status: 'APPROVED',
        wallet: {
          id: '987654321098765432109876543210987654',
          balance: 135.5,
          documentNumber: '98765',
          currency: {
            code: 'USD',
            exchangeBuy: 1.0,
            exchangeSell: 1.0,
            mainCurrency: true
          },
          status: 'ACTIVE'
        },
        createAt: '2025-09-04T12:45:33.112Z',
        details: {
          currencyCalculation: {
            BS: {
              amount: 100.0,
              exchangeRate: 36.5
            },
            USD: {
              amount: 2.74,
              exchangeRate: 1.0
            }
          }
        }
      },
      payPhone: null,
      bankOrigin: null,
      exchangeRate: 36.8,
      file: 'transfer_TRF000019_20250904124533112.png'
    }
  ]
}
